"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataList = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var DataListHeaderRow_1 = require("./DataListHeaderRow");
var DataListHeaderCell_1 = require("./DataListHeaderCell");
var DataListRow_1 = require("./DataListRow");
var DataListCell_1 = require("./DataListCell");
var DataList = function (_a) {
    var children = _a.children, className = _a.className, header = _a.header, items = _a.items, _b = _a.spacing, spacing = _b === void 0 ? 2 : _b, simple = _a.simple, props = __rest(_a, ["children", "className", "header", "items", "spacing", "simple"]);
    var generateRows = function (header, items) {
        var actualheader = Array.isArray(header)
            ? header
            : [header];
        var headersProperties = actualheader.map(function (headerCell) { return headerCell.props; });
        var rows = items.map(function (item, index) {
            return (react_1.default.createElement(DataListRow_1.DataListRow, { key: index }, generateCells(item, headersProperties)));
        });
        return rows;
    };
    var generateCells = function (item, headersProperties) {
        return headersProperties.map(function (headerProperties, index) {
            var name = headerProperties.name, content = headerProperties.content, children = headerProperties.children, className = headerProperties.className, cellProperties = __rest(headerProperties, ["name", "content", "children", "className"]);
            return (react_1.default.createElement(DataListCell_1.DataListCell, __assign({ key: index }, cellProperties), item[headerProperties.name]));
        });
    };
    var classes = classnames_1.default('DataList', className, "DataList--spacing-" + spacing, {
        'DataList--Simple': simple,
    });
    var headerRow = (react_1.default.createElement(DataListHeaderRow_1.DataListHeaderRow, null, header));
    var rows = children || generateRows(header, items);
    return (react_1.default.createElement("div", __assign({ className: classes }, props),
        headerRow,
        rows));
};
exports.DataList = DataList;
exports.DataList.HeaderRow = DataListHeaderRow_1.DataListHeaderRow;
exports.DataList.HeaderCell = DataListHeaderCell_1.DataListHeaderCell;
exports.DataList.Row = DataListRow_1.DataListRow;
exports.DataList.Cell = DataListCell_1.DataListCell;
//# sourceMappingURL=DataList.js.map